import { createTheme } from "@mui/material";
import { join } from 'lodash-es';

declare module '@mui/material/styles' {
	interface PaletteColor {
		brand?: string;
		heading?: string;
		shadow?: string;
		backgroundLight?: string;
		backgroundHover?: string;
	}
	interface SimplePaletteColorOptions {
		brand?: string;
		heading?: string;
		shadow?: string;
		backgroundLight?: string;
		backgroundHover?: string;
	}
}

declare module '@mui/material/styles' {
	interface BreakpointOverrides {
		xs: true;
		s: true;
		sm: true;
		md: true;
		lg: true;
		xl: true;
		xxl: true;
	}
}

export const BACKGROUND_COLOR_LIST: string[] = [
	'#FF6000',
];

export const Colors = {
	'110A20': '#110A20',
	'131415': '#131415',
	'252523': '#252523',
	'5F4A3B': '#5F4A3B',
	'2B2C2E': '#2B2C2E',
	'393739': '#393739',
	'3C3939': '#3C3939',
	'958579': '#958579',
	'D19364': '#D19364',
	'FB9C5C': '#FB9C5C',
	'FAC23A': '#FAC23A',
	'FFF521': '#FFF521',
	'FA5634': '#FA5634',
	'FF6000': '#FF6000',
	'FA6434': '#FA6434',
	'D32F2F': '#D32F2F',
	'F9172F': '#F9172F',
	'F0EBE8': '#F0EBE8',
	'F7DCC9': '#F7DCC9',
	'F7F3F0': '#F7F3F0',
	'F8F4F2': '#F8F4F2',
	'F6F6F6': '#F6F6F6',
	'FFFDF7': '#FFFDF7',
	'F8F7F6': '#F8F7F6',
	'F9F7F4': '#F9F7F4',
	'D8D8D8': '#D8D8D8',
	'A2A9B2': '#A2A9B2',
	'EDEDED': '#EDEDED',
	'F4F4F4': '#F4F4F4',
	'F7F7F7': '#F7F7F7',
	'BDBDBD': '#BDBDBD',
	'B4A5A1': '#B4A5A1',
	'848382': '#848382',
	'868078': '#868078',
	'6D7275': '#6D7275',
	'6F767E': '#6F767E',
	'747372': '#747372',
	'4F5069': '#4F5069',
	'76767B': '#76767B',
	'767A80': '#767A80',
	'BDE2F3': '#BDE2F3',
	'58B8FF': '#58B8FF',
	'2F1BE7': '#2F1BE7',
	'321AF1': '#321AF1',
	'1F2021': '#1F2021',
	'120E0D': '#120E0D',
	'351700': '#351700',
	'BCA99A': '#BCA99A',
	'946E53': '#946E53',
	'8F6F57': '#8F6F57',
	'73716E': '#73716E',
	'383839': '#383839',
};

export const appZoom = 1;

export const theme = createTheme({
	breakpoints: {
		values: {
			xs: 0,
			s: 450,
			sm: 600,
			md: 900,
			lg: 1200,
			xl: 1536,
			xxl: 1920
		},
	},
	palette: {
		primary: {
			main: '#2B2D2F',
			light: "#FFFFFF",
			dark: '#131415',
			shadow: '#000000',
			brand: '#FA8334',
			heading: '#0B162B',
			backgroundLight: '#FABE2C',
			backgroundHover: 'rgba(246, 241, 237, 0.4)'
		},
		secondary: {
			main: '#868078',
			light: '#F7F3F0',
			brand: '#EB6D19',
			heading: '#8F6F57',
			backgroundLight: '#BAA697'
		},
		background: {
			default: '#292827',
			paper: '#F7F3F0',
		}
	},
	typography: {
		fontFamily: join(['Nunito', 'Reenie Beanie', 'Caveat', 'Montserrat', 'Avenir', 'sans-serif'], ',')
	},
	components: {
		MuiLink: {
			styleOverrides: {
				root: {
					cursor: 'pointer',
					textDecoration: 'none'
				}
			}
		},
	}
});
